module.exports = __webpack_public_path__ + "assets/img/new_school_icon.71da7cda.png";